
/* NJO YOUR BUNDLE — shared quote panel and SA Quote handoff */
document.addEventListener('DOMContentLoaded', function () {
  const bundle = document.getElementById('njo-quote-bundle');
  if (!bundle) return;

  const panel = bundle.querySelector('.njo-quote-bundle__panel');
  const container = bundle.querySelector('[data-bundle-items]');
  const totalElement = bundle.querySelector('[data-bundle-total]');
  const submitButton = bundle.querySelector('[data-bundle-submit]');
  if (!container || !totalElement || !submitButton) return;

  const storageKey = 'njo_quote_bundle';
  if (!(window.njoSelectedProducts instanceof Map)) {
    let saved = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(parsed)) saved = parsed;
    } catch (error) {
      console.warn('NJO: Could not read saved bundle', error);
    }
    window.njoSelectedProducts = new Map(saved);
  }
  const items = window.njoSelectedProducts;

  function saveBundle() {
    try {
      localStorage.setItem(storageKey, JSON.stringify([...items.entries()]));
    } catch (error) {
      console.warn('NJO: Could not save bundle', error);
    }
  }

  function updateRail() {
    const rail = document.querySelector('.grfq-quote-widget-label');
    if (!rail) return;
    const count = [...items.values()].reduce(function (sum, item) {
      return sum + (Number(item.quantity) || 0);
    }, 0);
    const label = rail.querySelector('span');
    if (label) label.textContent = 'VIEW BUNDLE (' + count + ')';
    if (rail.dataset.njoBundleConnected === 'true') return;
    rail.dataset.njoBundleConnected = 'true';
    rail.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.njoBundle.open();
    }, true);
  }

  function renderGlobal() {
    container.replaceChildren();
    let total = 0;
    items.forEach(function (product, id) {
      const row = document.createElement('div');
      row.style.cssText = 'padding:16px 0;border-bottom:1px solid #ddd;';
      const name = document.createElement('strong');
      name.textContent = product.title || 'Product';
      const details = document.createElement('p');
      details.textContent = (product.price || '$0.00') + ' × ' + product.quantity;
      const controls = document.createElement('div');
      controls.style.cssText = 'display:flex;align-items:center;gap:12px;margin-top:12px;';
      const minus = document.createElement('button');
      minus.type = 'button';
      minus.textContent = '−';
      minus.addEventListener('click', function () {
        if (product.quantity > 1) product.quantity--;
        else items.delete(id);
        window.njoBundle.render();
      });
      const quantity = document.createElement('span');
      quantity.textContent = product.quantity;
      const plus = document.createElement('button');
      plus.type = 'button';
      plus.textContent = '+';
      plus.addEventListener('click', function () {
        product.quantity++;
        window.njoBundle.render();
      });
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        items.delete(id);
        window.njoBundle.render();
      });
      controls.append(minus, quantity, plus, remove);
      row.append(name, details, controls);
      container.appendChild(row);
      const unitPrice = parseFloat(String(product.price || '').replace(/[^0-9.]/g, '')) || 0;
      total += unitPrice * (Number(product.quantity) || 0);
    });
    if (items.size === 0) container.textContent = 'No products selected yet.';
    totalElement.textContent = total.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    submitButton.disabled = items.size === 0;
  }

  window.njoBundle = {
    getItems: function () { return items; },
    open: function () {
      bundle.hidden = false;
      panel?.focus();
    },
    close: function () { bundle.hidden = true; },
    render: function () {
      saveBundle();
      if (typeof window.njoRenderBundle === 'function') {
        window.njoRenderBundle();
      } else {
        renderGlobal();
      }
      submitButton.disabled = items.size === 0;
      updateRail();
    }
  };

  // Attach once, independently of whichever renderer the builder uses.
  submitButton.addEventListener('click', async function () {
    if (items.size === 0) return;
    const app = window.GRFQApp;
    const group = app?.productGroup?.groups?.[0];
    if (!group || typeof app.saveGroupToLocalStorage !== 'function' ||
        typeof app.openQuotePopup !== 'function' ||
        typeof app.encodeURIQuoteKey !== 'function') {
      alert('Quote service is not ready. Please try again.');
      return;
    }

    // Builder cards currently supply a product ID but not a variant ID.
    // Do not send invalid items to SA Quote or erase its saved group.
    const incomplete = [...items.values()].filter(function (item) {
      return !item.product_id || !item.variant_id || !Number.isFinite(Number(item.variant_id));
    });
    if (incomplete.length) {
      alert('Some bundle products need a variant selected before requesting a quote. Please open their product pages and add the desired variants.');
      return;
    }

    const oldItems = group.items;
    submitButton.disabled = true;
    try {
      const quoteItems = [...items.values()].map(function (item, index) {
        const quoteItem = {
          product_id: Number(item.product_id),
          name: item.title || '',
          vendor: item.vendor || '',
          variant_id: Number(item.variant_id),
          variant_name: item.variant_name || '',
          sku: item.sku || '',
          image: item.image || '',
          product_url: item.product_url || '',
          qty: Math.max(1, Number(item.quantity) || 1),
          price: Math.round((parseFloat(String(item.price || '').replace(/[^0-9.]/g, '')) || 0) * 100),
          options: item.variant_name || '',
          quoteId: index + 1
        };
        quoteItem.quoteKey = app.encodeURIQuoteKey(quoteItem);
        return quoteItem;
      });
      group.items = quoteItems;
      app.saveGroupToLocalStorage(0);
      const isUpfitting =
  window.location.pathname.includes('upfitting-build');

sessionStorage.setItem(
  'njo_quote_workflow',
  isUpfitting ? 'upfitting' : 'flatbed'
);

window.location.assign('/pages/request-for-quote');
    } catch (error) {
      group.items = oldItems;
      console.error('NJO quote handoff failed:', error);
      alert('Unable to open the quote form. Please try again.');
    } finally {
      submitButton.disabled = items.size === 0;
    }
  });

  // Individual product pages: intercept the SA Quote button.
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.product-form__quote.rfq-btn');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const product = window.ShopifyAnalytics?.meta?.product;
    const form = button.closest('form') || document.querySelector('form[action*="/cart/add"]');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const quantity = Math.max(1, parseInt(form?.querySelector('[name="quantity"]')?.value || '1', 10) || 1);
    if (!product || !variantId) {
      alert('Could not identify this product. Please try again.');
      return;
    }
    const variant = product.variants?.find(function (v) { return String(v.id) === String(variantId); });
    const title = product.title || document.querySelector('h1')?.textContent.trim() || 'Product';
    const priceCents = variant?.price ?? product.price ?? 0;
    const price = (Number(priceCents) / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const details = {
      title: title,
      price: price,
      product_id: product.id,
      variant_id: variantId,
      variant_name: variant?.public_title || '',
      vendor: product.vendor || '',
      sku: variant?.sku || '',
      product_url: window.location.pathname + '?variant=' + variantId,
      image: document.querySelector('meta[property="og:image"]')?.content || ''
    };
    const key = String(variantId);
    const existing = items.get(key);
    items.set(key, Object.assign({}, existing || {}, details, {
      quantity: (Number(existing?.quantity) || 0) + quantity
    }));
    window.njoBundle.render();
    window.njoBundle.open();
  }, true);

  // Closing via X or clicking the backdrop, without closing on panel clicks.
  bundle.addEventListener('click', function (event) {
    if (event.target.closest('[data-bundle-close]') || event.target === bundle) {
      window.njoBundle.close();
    }
  });

  window.njoBundle.render();
  updateRail();
  setTimeout(updateRail, 1500);
});
